import { formatDayMonthWord, getIsTariffAccumsFttbDivideEnabled } from '@beef/elk-common/utils';
export var getAccumulatorExpirationInfo = function getAccumulatorExpirationInfo(accumulator) {
  if (!accumulator) {
    return undefined;
  }
  var resetDateTimeUtc = accumulator.resetDateTimeUtc,
    displayUnit = accumulator.displayUnit,
    resetDate = accumulator.resetDate;
  var resetAccumDate = getIsTariffAccumsFttbDivideEnabled() ? resetDateTimeUtc : resetDate;
  if (!displayUnit) {
    return undefined;
  }
  return "\u0434\u043E\u043F ".concat(displayUnit.toLowerCase(), " \u0434\u043E ").concat(formatDayMonthWord(resetAccumDate));
};